import {
  type ThemeOptions,
  type ComponentsProps,
  type ComponentsOverrides,
  type ComponentsVariants,
  alpha
} from '@mui/material/styles';
import type { Theme } from '@ui/ThemeRegistry/theme.types';

const defaultProps: ComponentsProps['Media'] = {
  nextImageOptimization: true,
  priority: false,
  sizes: '100vw' // All images are shown close to full bleed size
};

const styleOverrides: ComponentsOverrides<Theme>['Media'] = {
  // Set some static styles
  root: ({ theme, ownerState }) => ({
    'main > &': {
      margin: '0 auto'
    },

    // img default display: inline introduces a line-height space at the bottom
    'display': 'block',
    'maxWidth': `100%`,
    'height': 'auto',
    'borderRadius': theme.spacing(3),

    ...(ownerState?.rounded && {
      [theme.containerBreakpoints.up('sm')]: {
        borderRadius: theme.spacing(4)
      }
    }),

    ...(!ownerState?.rounded
      ? {
          borderRadius: 'unset !important'
        }
      : {}),

    ...(ownerState?.variant === 'video'
      ? {
          backgroundColor: '#000'
        }
      : {}),

    '&[class*=Media-videoWrapper]': {
      position: 'relative',
      width: '100%',
      height: '100%',
      cursor: 'pointer'
    },

    '&[class*=Media-playIcon]': {
      position: 'absolute',
      height: 'fit-content',
      width: 'fit-content',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: 'white',
      backgroundColor: 'var(--mui-palette-schemes-white-primary-main) !important',
      borderRadius: '50%',
      padding: theme.spacing(3),
      maxHeight: '72px',
      maxWidth: '72px'
    },

    '&[class*=Media-embedWrap]': {
      position: 'relative',
      width: ' 100%',
      paddingBottom: '56.25%',
      overflow: 'hidden',
      display: 'block',

      iframe: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 'none'
      }
    }
  })
};

const createVariants = (_theme: Theme): ComponentsVariants['Media'] => [];

export const mediaTheme = (theme: Theme): ThemeOptions => ({
  components: {
    Media: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});

export default mediaTheme;
